(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4783],{

/***/ 86394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5678);
/* harmony import */ var _components_pages_profiles_agent_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68915);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);






var AgentProfilePage = function AgentProfilePage(_ref) {
  var data = _ref.data,
      id = _ref.id,
      messages = _ref.messages,
      url = _ref.url;

  var _useSessionStorage = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_1__/* .useSessionStorage */ .Xs)("code", {
    id: null,
    type: null
  }),
      _useSessionStorage2 = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useSessionStorage, 2),
      code = _useSessionStorage2[0],
      setCode = _useSessionStorage2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setCode({
      id: id,
      type: "referer"
    });
  }, [id, setCode]);
  var configProfile = {
    id: id,
    IsUserCollection: false,
    data: data
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_pages_profiles_agent_profile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, configProfile);
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AgentProfilePage);

/***/ }),

/***/ 4718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agente/[...params]",
      function () {
        return __webpack_require__(86394);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,8584,8360,2966,2203,6869,3405,8654,9470,4003,1691,2098,2737,7814,8915,9774,2888,179], function() { return __webpack_exec__(4718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);